import angular from 'angular';

export default angular.module('components.help', [])
    .component('help', {
        template: require('./index.pug')()
    })
    .name; 
